import { format } from 'date-fns';
import { DateLike, localEquivalentOfUTC } from 'mapistry-shared';
import React from 'react';
import { NoWrap } from './styled';

export const DateTableCell = ({ value }: { value: DateLike }) => (
  <NoWrap>{format(localEquivalentOfUTC(new Date(value)), 'P')}</NoWrap>
);
